import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import ApplyPaymentItem from '../../../Domain/ApplyPaymentItem';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ClientPaymentService from '../../../Services/ClientPaymentService';
import AppliedInvoiceItem from '../../../Domain/AppliedInvoiceItem';
import ClientPaymentClientInvoiceSearchParams from './ClientPaymentClientInvoiceSearchParams';

export default class AppliedClientInvoiceAdmin extends React.Component {
  static defaultProps = {
    clientPaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      searchItem: new ClientPaymentClientInvoiceSearchParams(props.clientPaymentId, 'applied'),
    };

    this.refresh = this.refresh.bind(this);
    this.removePaymentFunction = this.removePaymentFunction.bind(this);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  removePaymentFunction() {
    const selectedItem = new ApplyPaymentItem();
    selectedItem.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
    selectedItem.ClientPaymentId = this.props.clientPaymentId;
    selectedItem.ClientInvoiceIds = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    selectedItem.InvoiceType = 'applied';

    ClientPaymentService.RemovePayment(selectedItem)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Payment removed from Invoice(s).');
        }
        ErrorMessage.SetLoading(false);
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('ACIA55', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  renderButtons() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.removePaymentFunction),
              label: 'Remove Payment(s)',
              tooltip: 'Remove Payment(s)',
              roleKey: 'clientpayment_remove',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
          ]}
        />
      </div>
    );
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Remove the payment of all currently selected (${this.state.numberOfElementsInTheTable}) Client Invoices?`;
    }
    const idList = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    return `Remove the payment of the selected ${idList.length} Client Invoice(s)?`;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtons()}
        <TabOfDataTable
          type={AppliedInvoiceItem}
          serviceFunction={ClientInvoiceService.ListApplied}
          convertDBItemsFunction={ClientInvoiceService.ConvertAppliedDBItems}
          searchItem={this.state.searchItem}
          orderBy='CiId'
          orderDirection='Desc'
          errorCode='ACIA109'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
        />
      </div>
    );
  }
}
